(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["filamelt-caliber-hub-styles"] && !Shopify.designMode) return;
  try {
    (() => {
    const desktop = window.matchMedia('(min-width: 750px)');
    const sync = () => document.querySelectorAll('.fm-hub-disclosure').forEach(details => {
      details.open = desktop.matches;
    });
    sync();
    desktop.addEventListener('change', sync);
    document.addEventListener('shopify:section:load', sync);
  })();
  } catch(e) { console.error(e); }
})();

})();
